import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { configureAlarms } from './alarms';
import { dataDelivery } from './data-delivery';
import { tritoninfo } from './triton-info';
import { avGatedSensor } from './sensors/av-gated';
import { peakComboSensor } from './sensors/peak-combo';
import { longRangeDepthSensor } from './sensors/long-range';
import { smartDepthSensor } from './sensors/smart-depth';
import { surfaceComboSensor } from './sensors/surface-combo';
import { dialogActions } from './dialog-actions';
import { TritonSensorNames } from '../../../location-card.constants';
import { LocationCardSettings } from '../../reducers';
import { mp1Flow } from './flow/mp1-flow';
import { TritonLocationCardState } from './models';
import { advanced } from './advanced';
import { Config } from 'app/shared/services/config';

/**
 * Triton form configuration
 */
export const tritonFormState = (state: TritonLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'triton-location-config',
                title: 'Triton+ Location Configuration',
            },
            sections: [
                basicInfo(state),
                tritoninfo(state),
                dataDelivery(state),
                configureAlarms(state),
                mp1Flow(state),
                advanced(state),
                dialogActions(state),
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };
};

export const getTritonSensorConfigByName = (
    sensorName: TritonSensorNames,
    mp: 0 | 1,
    index: 0 | 1,
    settings: LocationCardSettings,
    prepopulateValues?,
) => {
    mp = mp === null ? index : mp;

    switch (sensorName) {
        case TritonSensorNames.peakCombo:
        case TritonSensorNames.avMax: {
            return peakComboSensor(mp, settings, prepopulateValues);
        }
        case TritonSensorNames.avGated: {
            return avGatedSensor(mp, settings, prepopulateValues);
        }
        case TritonSensorNames.longRange: {
            return longRangeDepthSensor(mp, settings, prepopulateValues);
        }
        case TritonSensorNames.paraDepth:
        case TritonSensorNames.smartDepth: {
            return smartDepthSensor(mp, settings, prepopulateValues);
        }
        case TritonSensorNames.paraFlow:
        case TritonSensorNames.surfaceCombo: {
            return surfaceComboSensor(mp, settings, prepopulateValues);
        }
    }
};
